import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import { SaveQuizFromApiSlice } from "../../../redux/features/Quiz Management/QuizManagementByAPI";
import { toast } from "react-toastify";
import { Button, Modal, Form} from "react-bootstrap";
import { loader } from "../../../utils/helper";

const ImportQuizModal = ({ show, handleClose, onSumit }) => {
  const [formData, setFormData] = useState({
    papername: "",
    paperId: "",
    isTrending: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async() => { 
    console.log("Form Data:", formData);

    loader.start();
    const res = await onSumit(formData);
    loader.stop();
    if(res?.success){
      toast.success(res?.message || "Quiz imported successfully");
      setFormData({
        papername: "",
        paperId: "",
        isTrending: false,
      });
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header >
        <Modal.Title>Import Quiz</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Paper Name */}
        <div className="mb-3">
          <label className="form-label">Paper Name</label>
          <input
            type="text"
            className="form-control"
            name="papername"
            placeholder="Enter paper name"
            value={formData.papername}
            onChange={handleChange}
          />
        </div>

        {/* Paper ID */}
        <div className="mb-3">
          <label className="form-label">Paper ID</label>
          <input
            type="text"
            className="form-control"
            name="paperId"
            placeholder="Enter paper ID"
            value={formData.paperId}
            onChange={handleChange}
          />
        </div>

        {/* Trending Checkbox */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="isTrending"
            name="isTrending"
            checked={formData.isTrending}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="isTrending">
            Mark as Trending
          </label>
        </div>

        {/* Debug (optional) */}
        {/* <p>Trending: {formData.isTrending ? "Yes" : "No"}</p> */}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={()=>{
          setFormData({
            papername: "",
            paperId: "",
            isTrending: false,
          });
          handleClose()
          }}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} style={{backgroundColor:"#e3083f",outline:"none",border:"none",border:"none"}}>
          Import
        </Button>
      </Modal.Footer>
    </Modal>
  );
};


const QuizUploadByApiOutlet = () => {
  const location = useLocation().pathname.split("/").splice(1);

  const dispatch = useDispatch();


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);   

  const hanldeFetchQuiz=useCallback(async(data)=>{

    if(data.paperId){
try {
  try {
    
   const response = await dispatch(SaveQuizFromApiSlice(data)).unwrap();
   console.log("response:",response);
   return response;
  } catch (error) {
    
  }
        
} catch (error) {
  toast.error(error.message || "Something went wrong");
} 
    }{
      toast.error("please enter quiz id to fetch!")
    }
  })

  return (
    <>
      <div className="TitleBox">
        {!location?.includes("ViewQuizByApi")&& !location?.includes("EditQUIZ") && (
          <h4 className="Title">Quiz Management</h4>
        )}
      </div>
      {!location?.includes("QuizCategory") && !location?.includes("ViewQuizByApi") && !location?.includes("EditQUIZ")&& (
          <>
            <div className="CommonTabs">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location?.includes("PendingQuizByApi") && "active"
                    }`}
                    data-toggle="tab"
                    to={"PendingQuizByApi"}
                  >
                    All Pending Quiz
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location?.includes("AllPublishedQuizByApi") && "active"
                    }`}
                    data-toggle="tab"
                    to={"AllPublishedQuizByApi"}
                  >
                    All Published Quiz
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location?.includes("RejectedQuizByApi") && "active"
                    }`}
                    data-toggle="tab"
                    to={"RejectedQuizByApi"}
                  >
                    Rejected Quiz
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location?.includes("DeletedQuizByApi") && "active"
                    }`}
                    data-toggle="tab"
                    to={"DeletedQuizByApi"}
                  >
                    Deleted Quiz
                  </Link>
                </li>
                {/* <li className="nav-item d-flex">
                  <input
                    type="text"
                    name="QuizByApi"
                    id="QuizByApi"
                    value={saveId}
                    className="form-control w-75" 
                    placeholder="Quiz id"
                    title="Please enter Quiz id"
                    style={{ height: "40px" }}
                    onChange={(e) => {
                      if(e.target.value === " "){
                        e.target.value=""
                      }
                      setSaveId(e.target.value);
                    }}
                  />
                  <button type="button" onClick={hanldeFetchQuiz} class="ml-3 btn btn-primary">
                    Submit
                  </button>
                </li> */}

                <li className="nav-item">
                    <Button variant="primary" onClick={handleShow} style={{backgroundColor:"#e3083f",outline:"none",border:"none",borderRadius:"5px",padding:"8px 26px"}}>
                      Import Quiz
                    </Button> 
                </li>
              </ul>
            </div>

            {/* <div className="TitleBox">
        <h4 className="Title" />
        <span>
          {" "}
          <Link
            className="TitleLink"
            data-toggle="modal"
            to={"QuizCategory"}
          >
          Quiz Category
          </Link>

          <Link className="TitleLink" to={"/QuizManagement/AddQUIZ"}>
            Add Quiz{" "}
          </Link>
        </span>
      </div> */}
          </>
        )}
      <div className="ModalBox">
        <div id="LogoutModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Logout</h3>
                  <p>Are you sure you want to log out? </p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="login.html">Yes</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="DeleteModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Delete</h3>
                  <p>Are you sure you want to Delete? </p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="ActiveModal"
          className="modal fade ExtraSmallModal"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Active</h3>
                  <p>Are you sure you want to active?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="InactiveModal"
          className="modal fade ExtraSmallModal"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Inactive</h3>
                  <p>Are you sure you want to inactive ?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div
          id="AddQuizCategoryModal"
          className="modal fade"
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Category">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Add QUIZ Category</h3>
                  <div className="form-group">
                    <label>Category Title</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Auto fill "
                    />
                  </div>
                  <div className="form-group">
                    <label>Upload Image </label>
                    <div className="UploadBox">
                      <div className="Upload">
                        <i className="fa fa-upload" /> <span>Upload </span>
                        <input type="file" />
                      </div>
                    </div>
                  </div>
                  <button className="Button">Add Quiz Category</button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <Outlet />

      <ImportQuizModal show={show} handleClose={handleClose} onSumit={hanldeFetchQuiz} />
    </>
  );
};

export default QuizUploadByApiOutlet;
